(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
  const scan = () => {
    document.querySelectorAll('[data-jm-upload-label]').forEach((note) => {
      const form = note.closest('form');
      if (!form) return;
      form.querySelectorAll('.gpo-app input[type="file"]').forEach((input) => {
        if (input.required || input.closest('.jm-upload-accordion')) return;
        const element = input.closest('.gpo-element');
        if (!element || element.querySelector('[required], [aria-required="true"]')) return;
        const details = document.createElement('details');
        details.className = 'jm-upload-accordion';
        const summary = document.createElement('summary');
        summary.textContent = note.dataset.jmUploadLabel;
        details.appendChild(summary);
        note.insertAdjacentElement('afterend', details);
        details.appendChild(element);
        note.hidden = true;
        input.addEventListener('change', () => {
          if (input.files?.length) details.open = true;
        });
      });
    });
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  };
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jm-production-note"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-jm-shop-pay]');
  if (!button) return;
  const scope = button.closest('section') || button.closest('[id^="MainProduct-"]') || document;
  const terms = scope.querySelector('shopify-payment-terms');
  const action = terms?.shadowRoot?.querySelector('#shopify-installments-cta');
  if (action) {
    action.click();
  } else {
    const instructions = button.parentElement.querySelector('.jm-shop-pay-instructions');
    instructions.hidden = false;
    instructions.setAttribute('tabindex', '-1');
    instructions.focus();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  const picker = event.target.closest('.jm-mount-buttons');
  if (!picker) return;
  const fieldset = event.target.closest('fieldset');
  const label = fieldset?.querySelector('[data-jm-selected-mount]');
  const selected = fieldset?.querySelector('input:checked');
  if (label && selected) {
    const previous = label.textContent;
    const separator = previous.indexOf(':');
    label.textContent = previous.slice(0, separator + 1) + ' ' + selected.value;
  }
});
  } catch(e) { console.error(e); }
})();

})();
